module.exports = __webpack_public_path__ + "static/media/speakers_logos_Towngas.acca4c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Towngas.jpg
// module id = 280
// module chunks = 0